// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * Filters all undefined keys from the object
 * @param {object} obj Object that needs to be cleared from undefined
 *
 * @returns {object}
 */
const objectWithoutUndefined = obj => {
  const newObj = {}
  Object.entries(obj).forEach(([k, v]) => {
    if (v === undefined) return
    newObj[k] = v
  })
  return newObj
}

/**
 * Checks whether valie is not null or undefined
 * @param {any} val
 *
 * @returns {boolean}
 */
const isDefined = val => val !== undefined && val !== null

/**
 * Checks whether all fields are present in the received object
 * @param {object} object Checked object
 * @param {array<string>} fieldsArr MMandatory fields
 *
 * @returns {boolean}
 */
const objectContainFields = (object, fieldsArr) => {
  let objectContainAllMandatoryFields = true

  fieldsArr.forEach(key => {
    if (!object.hasOwnProperty(key)) {
      objectContainAllMandatoryFields = false
    }
  })

  return objectContainAllMandatoryFields
}

export { objectWithoutUndefined, isDefined, objectContainFields }



// WEBPACK FOOTER //
// ./src/shared/libraries/utils/object.js